import { useEffect, useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { captureException } from '../utils/sentryUtils';
const USERS_BY_SCOPE_FIELD = 'usersByScope';
const FETCH_USERS_BY_SCOPE = registerQuery({
  fieldName: USERS_BY_SCOPE_FIELD,
  args: ['scope'],
  fetcher: ({
    scope
  }) => http.get(`permissions-skynet/v1/scopes/app/${scope}/hub-users`)
});
const sortUsers = unsortedUsers => [...unsortedUsers].sort((a, b) => a.firstName.toLocaleLowerCase() < b.firstName.toLocaleLowerCase() ? -1 : 1);
export const useFetchUsersByScope = (scope, options = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_USERS_BY_SCOPE, {
    variables: {
      scope
    },
    skip: options.skip
  });
  useEffect(() => {
    if (error) {
      captureException(error, {
        extra: {
          fingerprint: 'useFetchUsersByScope'
        }
      });
    }
  }, [error]);
  const users = useMemo(() => {
    var _data$USERS_BY_SCOPE_;
    const rawUsers = (_data$USERS_BY_SCOPE_ = data === null || data === void 0 ? void 0 : data[USERS_BY_SCOPE_FIELD]) !== null && _data$USERS_BY_SCOPE_ !== void 0 ? _data$USERS_BY_SCOPE_ : [];
    return sortUsers(rawUsers);
  }, [data]);
  return {
    isLoading: loading,
    users
  };
};